import './assets/Button.css';import { jsxs as B, Fragment as k, jsx as t } from "react/jsx-runtime";
import N from "classnames";
import { forwardRef as x } from "react";
import n from "./components/icon/Icon.js";
import { ButtonLoadingIndicator as j } from "./components/button/ButtonLoadingIndicator.js";
const L = "_link_1a1m1_8", C = "_button_1a1m1_8", F = "_loading_1a1m1_18", R = "_loader_1a1m1_21", q = "_disabled_1a1m1_50", z = "_fullwidth_1a1m1_88", A = "_active_1a1m1_103", D = "_small_1a1m1_116", E = "_medium_1a1m1_124", G = "_large_1a1m1_132", H = "_primary_1a1m1_140", I = "_secondary_1a1m1_157", J = "_tertiary_1a1m1_174", K = "_destructive_1a1m1_181", a = {
  link: L,
  button: C,
  loading: F,
  loader: R,
  disabled: q,
  fullwidth: z,
  "fullwidth-mobile": "_fullwidth-mobile_1a1m1_88",
  active: A,
  small: D,
  medium: E,
  large: G,
  primary: H,
  "primary-on-accent": "_primary-on-accent_1a1m1_150",
  secondary: I,
  "secondary-on-accent": "_secondary-on-accent_1a1m1_167",
  tertiary: J,
  destructive: K
}, M = ({ children: e, trailingIcon: s, leadingIcon: o, loading: m }) => /* @__PURE__ */ B(k, { children: [
  m && /* @__PURE__ */ t(j, { className: a.loader }),
  !!o && /* @__PURE__ */ t(n, { name: o }),
  !!e && /* @__PURE__ */ t("span", { children: e }),
  !!s && /* @__PURE__ */ t(n, { name: s })
] }), U = x(
  ({
    active: e,
    children: s,
    className: o,
    destructive: m = !1,
    disabled: _,
    trailingIcon: l,
    leadingIcon: i,
    representation: c = "button",
    id: d,
    isFullwidth: u = !1,
    isFullwidthMobile: f = !1,
    loading: r = !1,
    onClick: y,
    size: b = "medium",
    type: p,
    variant: h = "primary",
    ...w
  }, v) => {
    const g = N(
      a[c],
      a[b],
      a[h],
      {
        [a.destructive]: m,
        [a.loading]: r,
        [a.fullwidth]: u,
        [a["fullwidth-mobile"]]: f
      },
      o
    );
    return /* @__PURE__ */ t(
      "button",
      {
        "data-testid": "button",
        className: g,
        "aria-selected": e,
        disabled: _ || r,
        ref: v,
        id: d,
        type: p,
        onClick: y,
        ...w,
        children: /* @__PURE__ */ t(M, { leadingIcon: i, trailingIcon: l, loading: r, children: s })
      }
    );
  }
);
export {
  U as B,
  M as a,
  a as s
};
